import * as React from "react";
import { AmountFieldSchema } from "@generation/core/src/Schema/Fields";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import "./ReadItem.scss";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { ItemValue } from "../Components/ItemValue";
import { useDataContext, getValueFromObject } from "@generation/overview-core";
import {
  convertLocalizedNumberStringToFloat,
  getDutchDecimalFormat,
  stringIsNotNullOrUndefined
} from "@core/utils";
import { getValuesPropertyMap } from "@generation/core";

export interface AmountItemProps {
  name: string;
  field: AmountFieldSchema;
}

export const AmountItem = withHideOnFieldHoc(
  withRenderFieldHoc((props: AmountItemProps): JSX.Element => {
    let value: string | null | undefined = getValueFromObject(useDataContext(), props.name);
    if (props.field.overview?.formatValue) {
      value = props.field.overview.formatValue(value);
    } else {
      value = stringIsNotNullOrUndefined(value) ? value : props.field.overview?.valueWhenNotGiven?.toString();

      const parsedValue = value ? convertLocalizedNumberStringToFloat(value) : null;

      if (parsedValue != null) {
        value = `${getDutchDecimalFormat(parsedValue, props.field.decimalScale ?? null)}`;
      }
    }

    const beforeTextValue = getBeforeTextValue(props, value);

    if (beforeTextValue) {
      value = `${beforeTextValue} ${value}`;
    }

    const renderValue = props.field.overview?.render?.(value) ?? value;

    return <ItemValue value={renderValue} />;
  })
);

const getBeforeTextValue = (
  props: AmountItemProps,
  value: string | null | undefined
): string | null | undefined => {
  if (!value) {
    return null;
  }

  if (props.field.overview?.beforeText?.text) {
    return props.field.overview.beforeText?.text;
  }

  if (props.field.overview?.beforeText?.valueOfProperty) {
    let property =
      props.field.overview.beforeText.isAbsolutePath === true
        ? props.field.overview.beforeText.valueOfProperty
        : `${props.name.substring(0, props.name.lastIndexOf("."))}.${
            props.field.overview.beforeText.valueOfProperty
          }`;

    return getValuesPropertyMap(useDataContext(), [property], getValueFromObject)[property];
  }

  return null;
};
